module.exports = __webpack_public_path__ + "media/images/front/top/swiper_arrow-648875701ce081a820d5001e07455e2b.png";